/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { closeModal } from 'redux-app/modules/modals'
import { getModalStatusByName } from 'redux-app/selectors/modals'
import Modal from './Modal'

export default compose(
  connect(
    (state, { name, isOpen }) => ({
      isOpen: isOpen !== undefined ? isOpen : getModalStatusByName(state, name),
    }),
    {
      closeModal: name => closeModal(name),
    },
  ),
)(Modal)
